export class ResetPasswordEntity {
    public newPassword: string;
    public newPasswordRepeat: string;
}
